import { PDT_SCAN_STATUS, type QueryRefetchIntervals, REFETCH_INTERVAL } from '@access-cms/shared-constants';

function isPdtScanInProgress(pdtScanStatus: string | null | undefined): boolean {
  return pdtScanStatus === PDT_SCAN_STATUS.PENDING || pdtScanStatus === PDT_SCAN_STATUS.SCANNING;
}

/**
 * Determines PDT refetch interval. Polls the labor-category list often while
 * a PDT malware scan is in flight. Reverts to a slower polling interval once
 * every PDT in the list is in a terminal state (i.e. not SCANNING).
 */
export function getLaborCategoryListRefetchInterval(
  laborCategories: Array<{ pdtScanStatus?: string | null }>,
): QueryRefetchIntervals {
  const hasInProgressPdtScan = laborCategories.some((category) => isPdtScanInProgress(category.pdtScanStatus));

  return hasInProgressPdtScan ? REFETCH_INTERVAL.refetchEvery3Seconds : REFETCH_INTERVAL.refetchEvery5Minutes;
}
